import { render, staticRenderFns } from "./profileSteps.vue?vue&type=template&id=5323ce73&scoped=true"
import script from "./profileSteps.vue?vue&type=script&lang=js"
export * from "./profileSteps.vue?vue&type=script&lang=js"
import style0 from "./profileSteps.vue?vue&type=style&index=0&id=5323ce73&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5323ce73",
  null
  
)

export default component.exports